/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const tagTokens = {
  BackgroundColorInformationalDefault: '#eaf0f8',
  BackgroundColorInformationalHover: '#c0d1e9',
  BackgroundColorInformationalDown: '#8babd6',
  BackgroundColorInformationalActiveDefault: '#285da3',
  BackgroundColorInformationalActiveHover: '#2c67b5',
  BackgroundColorInformationalActiveDown: '#1a3e6d',
  BackgroundColorNegativeDefault: '#f8d2d8',
  BackgroundColorPositiveDefault: '#d6efec',
  BackgroundColorNeutralDefault: '#ebecec',
  BackgroundColorPendingDefault: '#fef8da',
  BackgroundColorNoticeDefault: '#fcf0ee',
  BackgroundColorOrangeLightDefault: '#fae5de',
  BackgroundColorOrangeMediumDefault: '#efb09c',
  BackgroundColorOrangeDarkDefault: '#a0563f',
  BackgroundColorRedLightDefault: '#fbe8ec',
  BackgroundColorRedMediumDefault: '#f0a4b1',
  BackgroundColorRedDarkDefault: '#c41936',
  BackgroundColorGreenLightDefault: '#addfd9',
  BackgroundColorGreenMediumDefault: '#5bc0b3',
  BackgroundColorGreenDarkDefault: '#1e6a60',
  BackgroundColorLimeLightDefault: '#ebfcac',
  BackgroundColorLimeMediumDefault: '#c9ec56',
  BackgroundColorLimeDarkDefault: '#536507',
  BackgroundColorYellowLightDefault: '#fef8da',
  BackgroundColorYellowMediumDefault: '#fbe284',
  BackgroundColorYellowDarkDefault: '#ddb31f',
  BackgroundColorBlueLightDefault: '#dfe8f4',
  BackgroundColorBlueMediumDefault: '#285da3',
  BackgroundColorBlueDarkDefault: '#1a3e6d',
  BackgroundColorGrayLightDefault: '#ebecec',
  BackgroundColorGrayMediumDefault: '#c4c4c4',
  BackgroundColorGrayDarkDefault: '#656b6b',
  BackgroundColorPurpleLightDefault: '#e1ddf2',
  BackgroundColorPurpleMediumDefault: '#7358b8',
  BackgroundColorPurpleDarkDefault: '#453371',
  BackgroundColorTurquoiseLightDefault: '#c8f0f0',
  BackgroundColorTurquoiseMediumDefault: '#8cdfe1',
  BackgroundColorTurquoiseDarkDefault: '#127375',
  BorderRadiusBaseDefault: '4px',
  BorderRadiusMiniDefault: '4px',
  BorderWidthBaseDefault: '1px',
  BorderColorInformationalDefault: '#8babd6',
  BorderColorPositiveDefault: '#32b0a0',
  BorderColorNegativeDefault: '#e14963',
  BorderColorNeutralDefault: '#a7aaaa',
  BorderColorPendingDefault: '#f8d648',
  BorderColorNoticeDefault: '#e57b5a',
  FontSizeBaseDefault: '12px',
  FontWeightBaseDefault: '500',
  FontColorInformationalDefault: '#285da3',
  FontColorInformationalActiveDefault: '#eaf0f8',
  FontColorInformationalButtonDefault: '#1a3e6d',
  FontColorPositiveDefault: '#1e6a60',
  FontColorNegativeDefault: '#831124',
  FontColorNeutralDefault: '#394040',
  FontColorPendingDefault: '#825a00',
  FontColorNoticeDefault: '#a0563f',
  FontColorOrangeLightDefault: '#733e2d',
  FontColorOrangeMediumDefault: '#733e2d',
  FontColorOrangeDarkDefault: '#fcf0ee',
  FontColorRedLightDefault: '#831124',
  FontColorRedMediumDefault: '#831124',
  FontColorRedDarkDefault: '#fbe8ec',
  FontColorGreenLightDefault: '#144640',
  FontColorGreenMediumDefault: '#144640',
  FontColorGreenDarkDefault: '#ebf7f6',
  FontColorLimeLightDefault: '#536507',
  FontColorLimeMediumDefault: '#384202',
  FontColorLimeDarkDefault: '#fafdee',
  FontColorYellowLightDefault: '#825a00',
  FontColorYellowMediumDefault: '#4d2f00',
  FontColorYellowDarkDefault: '#4d2f00',
  FontColorBlueLightDefault: '#1a3e6d',
  FontColorBlueMediumDefault: '#eaf0f8',
  FontColorBlueDarkDefault: '#eaf0f8',
  FontColorGrayLightDefault: '#232b2b',
  FontColorGrayMediumDefault: '#232b2b',
  FontColorGrayDarkDefault: '#f4f4f4',
  FontColorPurpleLightDefault: '#453371',
  FontColorPurpleMediumDefault: '#f0eef9',
  FontColorPurpleDarkDefault: '#f0eef9',
  FontColorTurquoiseLightDefault: '#127375',
  FontColorTurquoiseMediumDefault: '#0a595b',
  FontColorTurquoiseDarkDefault: '#f2fbfb',
  FontLeadingBaseDefault: '30px',
  FontLeadingMiniDefault: '20px',
  SpacingHorizontalBaseDefault: '8px',
  SpacingHorizontalDraggableDefault: '8px',
  SpacingHorizontalMiniDefault: '8px',
} as const;
